import {
	PHARMACY_PATIENT_ADD_NOTE_REPLY_REQUEST,
	PHARMACY_PATIENT_ADD_NOTE_REPLY_SUCCESS,
	PHARMACY_PATIENT_ADD_NOTE_REPLY_FAILURE
} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const pharmacyPatientAddNoteReplyReducer = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_PATIENT_ADD_NOTE_REPLY_REQUEST:
		return {
			...state,
			loading: true,
			data: null,
			error: null,
		};
		case PHARMACY_PATIENT_ADD_NOTE_REPLY_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
			case PHARMACY_PATIENT_ADD_NOTE_REPLY_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		default:
			return state;
	}
};

export default pharmacyPatientAddNoteReplyReducer;
